import { render, staticRenderFns } from "./idealindex.vue?vue&type=template&id=80d8a1dc&scoped=true"
import script from "./idealindex.vue?vue&type=script&lang=js"
export * from "./idealindex.vue?vue&type=script&lang=js"
import style0 from "./idealindex.vue?vue&type=style&index=0&id=80d8a1dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80d8a1dc",
  null
  
)

export default component.exports